<template>
  <div class="section4">
    <swiper :options="swiperOptions" :instanceName="2">
      <swiper-slide
        v-for="item of swiperList"
        :key="item.id"
        :style="{ backgroundImage: `url(${item.imgUrl})` }"
        data-aos="fade-left"
        data-aos-duration="1500"
      >
        <p>{{ item.title }}</p>
      </swiper-slide>
      <div v-if="isMobile" class="swiper-button-prev" slot="button-prev"></div>
      <div v-if="isMobile" class="swiper-button-next" slot="button-next"></div>
      <div class="swiper-pagination" slot="pagination"></div>
    </swiper>

    <div class="txt">
      <h3 class="title1" data-aos="fade-right" data-aos-duration="1000">
        全台最美<br />科學園區第一排
      </h3>
      <div
        class="title2"
        data-aos="fade-right"
        data-aos-duration="1000"
        data-aos-delay="100"
      >
        體驗/未來與成就
      </div>
      <div
        class="desc1"
        data-aos="fade-right"
        data-aos-duration="1000"
        data-aos-delay="200"
      >
        華亞科學園區
        <hr v-if="!isMobile" />
        <br v-if="isMobile" />樂善科技園區
        <hr v-if="!isMobile" />
        <br v-if="isMobile" />中華郵政物流中心
      </div>
      <div
        class="desc2"
        data-aos="fade-right"
        data-aos-duration="1000"
        data-aos-delay="300"
      >
        三大園區制霸A7高科技廊帶<br />領袖菁英首選住居
      </div>
    </div>
    <div class="title" data-aos="fade-up" data-aos-delay="300">
      <svg
        v-if="!isMobile"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 477.48 296.62"
      >
        <defs>
          <clipPath id="clip-path" transform="translate(-1.3 -28.72)">
            <rect class="cls-1" width="479" height="354" />
          </clipPath>
        </defs>
        <g id="圖層_2" data-name="圖層 2">
          <g id="圖層_2-2" data-name="圖層 2">
            <g class="cls-2">
              <path
                class="cls-3"
                d="M186.82,59.31h13.31v4.8H168.31v-4.8H181.1V55.75H172V51.1h9.15V47.64h-7.25V44.37a45.35,45.35,0,0,1-4.57,2.57A21.72,21.72,0,0,0,166,42.55a38.73,38.73,0,0,0,11.23-6.73h-3.87v-5h13.6c3,4.46,8.81,9,15.39,11.23a25.77,25.77,0,0,0-3.6,5,42.81,42.81,0,0,1-4.61-2.53v3.12h-7.29V51.1h9.26v4.65h-9.26ZM184,35.82a48.16,48.16,0,0,1-8,7.1h15.8a47.09,47.09,0,0,1-7.74-7.1Z"
                transform="translate(-1.3 -28.72)"
              />
              <path
                class="cls-3"
                d="M233.37,46.94a26.57,26.57,0,0,0-1.75-2.64c-19,.82-21.9.89-24.13,1.63a45.78,45.78,0,0,0-1.78-5.16,7,7,0,0,0,3.16-2.09,46.07,46.07,0,0,0,7.51-10l5.46,2.34a61.14,61.14,0,0,1-7.36,8.74l13.2-.34c-1.27-1.44-2.53-2.82-3.72-4.05l4.2-2.82c3.27,3.23,7.77,7.84,9.78,11Zm-25.09,1.11h25.94V64.89h-5.84V63.07H213.81v1.82h-5.53Zm5.53,5.17v4.64h14.57V53.22Z"
                transform="translate(-1.3 -28.72)"
              />
              <path
                class="cls-3"
                d="M251.18,42.74H246V30.8h24.76V42.74h-5.43V34.45H251.18Zm13.12-4.39H252.07V35.3H264.3Zm-12.23,1H264.3v3H252.07Zm22.49,10.33a23.66,23.66,0,0,1-4.13,8.55,21,21,0,0,0,5.87,2.23,18.44,18.44,0,0,0-3.16,4.2,21,21,0,0,1-6.24-2.94A24.74,24.74,0,0,1,261,65a18.68,18.68,0,0,0-2.56-3.83v3.76h-5V62c-4.2.41-8.36.82-11.67,1.16l-.37-4.61,3.08-.23V47.72h-2.75V43.48h33.49v4.24H258.39v13a17.66,17.66,0,0,0,4.75-2.45,22.68,22.68,0,0,1-3.15-5.1l1.89-.52h-2.49v-4h10.93l.89-.15Zm-25.39-1.93v.89h4.2v-.89Zm0,5.46h4.2v-.93h-4.2Zm15.5-.56a12.81,12.81,0,0,0,1.82,2.49,15.32,15.32,0,0,0,1.6-2.49Zm-11.3,5v-.75h-4.2V57.9Z"
                transform="translate(-1.3 -28.72)"
              />
              <path
                class="cls-3"
                d="M301.62,56.19c4,1.27,8.74,2.94,11.42,4.09L310.51,65a151.6,151.6,0,0,0-14.8-5.8l1.75-3h-1.12c-1.82,4.24-5.83,7.1-15.79,8.7A15.26,15.26,0,0,0,277.83,60c6.58-.82,10-2,11.82-3.83H279.58V51.66h12.19c.08-.45.11-.9.19-1.38H278.73V45.6h14V44.3H282V39.8h10.74V38.57H279.8V33.85h6.66a16.27,16.27,0,0,0-1.64-2.71l4.83-1.86a15.08,15.08,0,0,1,2.57,4.16l-1,.41h7.25a28.49,28.49,0,0,0,2.38-4.57l5.87,1.38c-.74,1.15-1.48,2.26-2.19,3.19h6.73v4.72h-13V39.8h11.16v4.5H298.31v1.3h14.57v4.68h-15.2c-.07.48-.11.93-.18,1.38h14.05v4.53Z"
                transform="translate(-1.3 -28.72)"
              />
              <path
                class="cls-3"
                d="M142,105.67v9.22h-5.31v-8.25l-10.74,2-.86-5.17,11.6-2.08V79.58H142v20.85l3.35-.59.82,5.09Zm-19.18-1.41a32.08,32.08,0,0,0-1.56-3.09v13.76H116V103.44a29.42,29.42,0,0,1-3.27,5.87,28.73,28.73,0,0,0-2.45-5.2,34.25,34.25,0,0,0,5-9h-4.58v-5H116V86.6c-1.22.19-2.45.37-3.64.49A18,18,0,0,0,111,82.92,57.35,57.35,0,0,0,123,79.84L126,84.26a42.71,42.71,0,0,1-4.72,1.34v4.46h4.58v5h-4.58v.11c1,.85,3.94,4,4.65,4.83Zm9.67-13.75a30,30,0,0,0-5.32-5.84l3.54-3a32.66,32.66,0,0,1,5.57,5.5Zm-3.16.93a34.6,34.6,0,0,1,5.84,5.5l-3.72,3.45a33.81,33.81,0,0,0-5.58-5.87Z"
                transform="translate(-1.3 -28.72)"
              />
              <path
                class="cls-3"
                d="M154.07,101.17H149V93h2.68L151,81.92a58.91,58.91,0,0,0,7.74-2.19l2.15,3a37.34,37.34,0,0,1-4.76,1.38l0,.71h4.42v3.23h-4.23l.07.86h4.2v1.48a21.89,21.89,0,0,0,2-1c-.6-.37-1.23-.74-1.79-1l2.46-2c.63.34,1.3.71,2,1.12a9.4,9.4,0,0,0,1.3-1.41l3.42,1a14.25,14.25,0,0,1-1.86,2.15,22.32,22.32,0,0,1,2,1.56L167.64,93a19.29,19.29,0,0,0-1.93-1.63A24.39,24.39,0,0,1,163.14,93h11.08l.11-.85H170.5V89h4.13l0-.86h-4V84.86h4.2l0-.86h-4.49V80.73h9.77c-.18,4-.48,8.73-.82,12.3h2.72v8.14h-5.35V96.86H154.07Zm13.35-15a19.34,19.34,0,0,0-1.64-1.33,20.49,20.49,0,0,1-2.71,1.63,23,23,0,0,0-2.75-2.34,21,21,0,0,0,2.56-1.26c-.59-.34-1.15-.67-1.71-1l2.38-2c.63.3,1.3.67,2,1a10.78,10.78,0,0,0,1.15-1.23l3.38,1a16.18,16.18,0,0,1-1.7,2c.59.44,1.15.89,1.59,1.26ZM156.67,93h5.65c-.44-.48-1.11-1.19-1.67-1.71v.86H156.6Zm25.73,15.35H168.57v1.71c0,2.31-.48,3.46-2.23,4.17a20.07,20.07,0,0,1-6.58.67,18,18,0,0,0-1.67-4.54c1.52.08,3.82.08,4.38.08s.78-.11.78-.56v-1.53H148.42v-4.23h14.83v-.71a29.63,29.63,0,0,0,3.16-1.82H155.86V97.9h15.5l1.11-.26,3,2.79c-1.75,1.23-3.79,2.53-5.91,3.72H182.4Z"
                transform="translate(-1.3 -28.72)"
              />
              <path
                class="cls-3"
                d="M218.79,80.92v34h-5.28v-1.22h-22V115h-5.06v-34Zm-5.28,28V85.75h-22v23.16h4.83a8.58,8.58,0,0,0-1.08-2.46c.56-.26,1.12-.67,1.12-2.08v-.52c-.82.3-1.6.56-2.38.78a25.26,25.26,0,0,0-2.49-2.9,35.52,35.52,0,0,0,6.09-1.78h-3.49V94.71h17.06V100h-7.47a22.19,22.19,0,0,1-3.57,2.3v2.34l4.12-.85a15.15,15.15,0,0,0,0,3.16c-5.12,1.19-6.76,1.63-7.54,2Zm-.93-15H192.47V91h7.59v-.93h-6V87.27h6V86h4.87v1.26h6.35v2.79h-6.35V91h7.65Zm-6.05,3.9v-.93h-8v.93Zm6.76,4.39a29.63,29.63,0,0,1-2.56,1.74c1,.75,2,1.49,2.71,2.12L210,108a72,72,0,0,0-8.25-6.24l3.19-1.71c.9.56,1.9,1.23,2.94,1.89a20.23,20.23,0,0,0,2.27-1.82Z"
                transform="translate(-1.3 -28.72)"
              />
              <path
                class="cls-3"
                d="M249.13,108.87a43.37,43.37,0,0,0,7.28-.56c.15,1.3.45,3.75.71,5-1.63.44-5.2.48-8.29.48H235.12c-7.1,0-10.37-2.15-10.37-9.81V85.41h-1.46V80.69h32v4.72H230v19c0,3.27.93,4.5,4.65,4.5ZM249.76,96H234.67V86.75h15.09Zm-5.35-5.84h-4.72v2.38h4.72Zm9.22,17.29H242.77V97.12h10.86ZM231,97.12h10.59v10.34H231Zm18,3.53h-1.82v3.27H249Zm-13.68,3.27H237v-3.27H235.3Z"
                transform="translate(-1.3 -28.72)"
              />
              <path
                class="cls-3"
                d="M294.33,85.67h-5.57a16.52,16.52,0,0,1,2,1.75l-2.83,2.45h2.72v10.19H279.13v1.49h13.64s0,1.22-.11,1.85c-.29,4.84-.7,7.33-1.67,8.4a4.51,4.51,0,0,1-3.12,1.49,34.51,34.51,0,0,1-4.76.15,11.38,11.38,0,0,0-1.52-4.91,26.09,26.09,0,0,0,3.56.15,1.77,1.77,0,0,0,1.27-.33,4.85,4.85,0,0,0,.63-2.34h-7.92v8.92h-5.28v-6.58a33.49,33.49,0,0,1-10.66,6.32,21.55,21.55,0,0,0-3.39-4.24,34.76,34.76,0,0,0,9.78-4.42h-6.65a97.84,97.84,0,0,0,1.37-10.34h9.55V94.26H263V90.51a36.21,36.21,0,0,0-3.49-3.65,20.76,20.76,0,0,0,5.28-7.62l4.76,1.42-.45,1h7.36v3.79a17.1,17.1,0,0,0,3.75-6.21l4.91,1.27c-.15.37-.3.78-.45,1.15h9.7Zm-7.8,4.2a24.64,24.64,0,0,0-3.24-2.82l1.64-1.38h-2.42a20.89,20.89,0,0,1-3,3.76,29.55,29.55,0,0,0-4-3.16c.23-.19.41-.37.6-.56h-4a16.47,16.47,0,0,1,2,2l-2.34,2.19Zm-19.7-4.16a29.38,29.38,0,0,1-3.2,4.16h6.43a38.23,38.23,0,0,0-3-2.86l1.45-1.3Zm18.47,8.55h-6.17v1.41h6.17Zm-11.45,5.8H269.1l-.19,1.49h4.94Z"
                transform="translate(-1.3 -28.72)"
              />
              <path
                class="cls-3"
                d="M331.55,94v5.91H296.91V94Z"
                transform="translate(-1.3 -28.72)"
              />
              <path
                class="cls-3"
                d="M369,106.23h-6.06v8.66h-5.1V79.58h5.1v6h5.46v4.83h-5.46v3h5v4.72h-5v3.23H369ZM351.14,79.58h4.8v15.8c0,7.54-.74,14.83-7.14,19.55a21.82,21.82,0,0,0-3.86-3.57,13.16,13.16,0,0,0,4.38-5.09c-1.15.48-2.3.93-3.38,1.33l-2-4.64c1.82-.45,4.31-1.23,6.92-2,.11-.89.18-1.82.22-2.78h-4.72V93.41h4.79v-3H346V85.56h5.13Zm-5.39,20.48c-1.07.33-2.15.63-3.27.93v8.4c0,2.34-.37,3.72-1.63,4.53s-3,1-5.43,1a19.08,19.08,0,0,0-1.34-5,25.87,25.87,0,0,0,2.87,0c.44,0,.59-.11.59-.59v-7.06l-3,.81L333.41,98c1.19-.23,2.61-.56,4.13-.9V91.36H334V86.42h3.5V79.65h4.94v6.77h3v4.94h-3V95.9l2.61-.67Z"
                transform="translate(-1.3 -28.72)"
              />
              <path
                class="cls-3"
                d="M12.68,227.78H10.56v-1.64h2.12v-1.31H14.5v1.31H19v1.64H14.5v1.36H12.68Zm-6.84,0H1.44v-1.64h4.4v-1.31H7.66v1.31H9.84v1.64H7.66v1.36H5.84Zm5.22,10v1.38H18v1.56H11.06v2.52H9.24v-2.52H2.36v-1.56H9.24v-1.38H1.3v-1.62H9.24V231.2H1.8v-1.56H18.68v1.56H11.06v4.92H19.2v1.62Zm-4.84-6.1v1.18H8.36v1.58H6.22v1.28H4.48V234.4H1.8v-1.58H4.48v-1.18Zm8,4v-1.36H12v-1.58h2.24v-1.1H16v1.1h2.6v1.58H16v1.36Z"
                transform="translate(-1.3 -28.72)"
              />
              <path
                class="cls-3"
                d="M41.16,240.64v1.7H23.3v-1.7h5.76v-3.22H24.68v-6.88h4.38V227.7h-5.3V226h17v1.68H35.24v2.82h4.5v6.88h-4.5v3.24ZM30.84,235.8v4.84h2.6V235.8h4.42v-3.68H33.44V227.7H30.86v4.44H26.5v3.66Z"
                transform="translate(-1.3 -28.72)"
              />
              <path
                class="cls-3"
                d="M61,238.06v5.12H59.2v-4.8l-6.3,1.06-.28-1.78,6.58-1.1V224.83H61v11.43l2.18-.36.28,1.74Zm-9.38-1a27.51,27.51,0,0,0-1.56-2.64v8.74H48.3v-8.1a19.41,19.41,0,0,1-2.56,4.66,11.74,11.74,0,0,0-.9-1.72,19.89,19.89,0,0,0,3.2-5.86H45.1v-1.74h3.2v-2.68c-.86.16-1.72.28-2.52.4a5.67,5.67,0,0,0-.52-1.44,30,30,0,0,0,6.36-1.62l1.06,1.52a18.89,18.89,0,0,1-2.58.76v3.06h2.8v1.74H50.1v.28c.6.62,2.3,2.66,2.68,3.18Zm5.52-7a16.27,16.27,0,0,0-3.1-2.9l1.22-1.06a16.48,16.48,0,0,1,3.18,2.78Zm-.5,5.26a17.22,17.22,0,0,0-3.34-3l1.18-1.08a18.81,18.81,0,0,1,3.42,2.84Z"
                transform="translate(-1.3 -28.72)"
              />
              <path
                class="cls-3"
                d="M69.48,235.76H67.72v-3.82h1.52L68.88,226a37.39,37.39,0,0,0,3.92-1l.8,1.1a18,18,0,0,1-2.94.78l.06.8h2.74v1.2H70.78l.06.92h2.7V231a11.59,11.59,0,0,0,1.68-.94,14,14,0,0,0-1.3-.72l.9-.78c.44.22.94.48,1.4.76a5.8,5.8,0,0,0,.9-1l1.26.4a10.27,10.27,0,0,1-1.1,1.22,10.18,10.18,0,0,1,1.32,1l-.94.86a9.48,9.48,0,0,0-1.34-1.06,15.4,15.4,0,0,1-1.8,1.18h7c0-.3.06-.6.1-.92H78.94V229.8h2.74l.08-.92H79v-1.2h2.8l0-.9H78.94v-1.22H83.7c-.1,2-.28,4.58-.44,6.38h1.52v3.82H82.94v-2.42H69.48Zm8.12-7.5a7.66,7.66,0,0,0-1.24-.94,11.79,11.79,0,0,1-1.72,1.1,9.2,9.2,0,0,0-1-.86,8.82,8.82,0,0,0,1.64-.92A10.81,10.81,0,0,0,74,226l.9-.78c.42.2.9.44,1.34.7a5.68,5.68,0,0,0,.84-.88l1.26.34a9.36,9.36,0,0,1-1,1.18,9.71,9.71,0,0,1,1.22.88ZM71,231.94H74.4a5.85,5.85,0,0,0-.94-.92H70.94Zm14.14,7.48H77.34v1.92c0,.88-.2,1.32-.9,1.56a10.91,10.91,0,0,1-3.3.26,6.59,6.59,0,0,0-.6-1.58c1.1,0,2.26,0,2.56,0s.42-.08.42-.34v-1.86h-8.2V237.9h8.2v-.72a19,19,0,0,0,2.7-1.36H71.06v-1.36h9.06l.4-.1,1.06,1a20.59,20.59,0,0,1-4.24,2.42v.16h7.78Z"
                transform="translate(-1.3 -28.72)"
              />
              <path
                class="cls-3"
                d="M106.56,225.68V243.2h-1.82v-.78H91.62v.78H89.88V225.68Zm-1.82,15.06V227.36H91.62v13.38Zm-.86-8.86H92.48v-1.1H97.3v-1H93.54v-1.08H97.3v-1H99v1h4v1.08H99v1h4.9Zm-5,6.28a4.32,4.32,0,0,0,0,1.14c-3.56,1-4.1,1.1-4.42,1.32a3.4,3.4,0,0,0-.46-1.06,1,1,0,0,0,.72-1.08v-1.14c-.64.24-1.28.46-1.9.64a7.36,7.36,0,0,0-.9-1.08,19.78,19.78,0,0,0,4.22-1.44H93.64v-2.9h9.2v2.9H98.3a11,11,0,0,1-2.14,1.28v2.06Zm-3.72-3.58h6v-1.12h-6Zm8.76,1.94a16.23,16.23,0,0,1-2,1.22c.8.56,1.54,1.1,2.08,1.56l-1.22.74a37.73,37.73,0,0,0-5.1-3.6l1.14-.66c.64.38,1.38.82,2.08,1.28a15.7,15.7,0,0,0,1.86-1.26Z"
                transform="translate(-1.3 -28.72)"
              />
              <path
                class="cls-3"
                d="M125.5,240.64a21.29,21.29,0,0,0,3.46-.24c.06.48.18,1.34.28,1.76a22.34,22.34,0,0,1-3.8.2h-8.38c-3.26,0-4.78-1-4.78-4.24v-10.8h-.8v-1.64h16.78v1.64H114.1v10.94c0,1.7.68,2.38,2.78,2.38Zm-.44-7.64H117.5v-4.54h7.56Zm-1.84-3.28h-4v2h4Zm4.1,9.64h-5.46v-5.22h5.46Zm-11.94-5.22h5.3v5.22h-5.3Zm10.32,1.32h-2.3V238h2.3ZM116.9,238h2.18v-2.58H116.9Z"
                transform="translate(-1.3 -28.72)"
              />
              <path
                class="cls-3"
                d="M140.76,224.75h1.54v22.49h-1.54Z"
                transform="translate(-1.3 -28.72)"
              />
              <path
                class="cls-3"
                d="M165.52,234.3H160.2v-7.64h1.6a16.24,16.24,0,0,0,.38-1.95l1.7.31c-.22.56-.44,1.14-.62,1.64h2.26Zm5,.78c0-.26-.1-.52-.16-.84a20.59,20.59,0,0,0-4,.66,12.31,12.31,0,0,0-.48-1.46c.38-.08.76-.48,1.24-1a22.35,22.35,0,0,0,1.4-1.86,12.14,12.14,0,0,0-2.34.44,7.76,7.76,0,0,0-.48-1.4c.28-.08.52-.4.8-.84a16.64,16.64,0,0,0,1.7-3.74l1.52.48a22.5,22.5,0,0,1-2,3.84l1.7-.16c.34-.56.64-1.14.92-1.7l1.4.76a31.51,31.51,0,0,1-3.68,5l2-.2c-.1-.44-.24-.86-.36-1.24l1.22-.32a25.9,25.9,0,0,1,.86,3.22Zm-11.88-.18c0-.26-.08-.56-.12-.9a20.07,20.07,0,0,0-4,.72,8.49,8.49,0,0,0-.48-1.42c.38-.08.76-.48,1.24-1.06.24-.28.76-1,1.34-1.82a6.92,6.92,0,0,0-2.06.4c-.08-.3-.32-1-.46-1.38.24-.06.52-.38.8-.82a17,17,0,0,0,1.64-3.62l1.46.54a21.4,21.4,0,0,1-1.94,3.68l1.4-.12c.36-.6.68-1.22,1-1.82l1.34.74a32.81,32.81,0,0,1-3.56,5l2-.24c-.1-.46-.22-.94-.3-1.36l1.24-.26a31.55,31.55,0,0,1,.72,3.4Zm5.24-6.84h-2.1v1.74h2.1Zm0,3.06h-2.1v1.78h2.1Zm-.08,4.76h7.94v1.54H163.8v5.72h-1.86v-5.72h-8v-1.54h8v-1.1h1.86Zm2.26,2a39.39,39.39,0,0,1,5.68,3.46l-1.18,1.36A36.75,36.75,0,0,0,165,239Zm-5,.78a14.12,14.12,0,0,1-6.34,3.92,7.22,7.22,0,0,0-1.24-1.56,13.11,13.11,0,0,0,6-3Z"
                transform="translate(-1.3 -28.72)"
              />
              <path
                class="cls-3"
                d="M193.78,235.28v1.46H175.92v-1.46h3.78a6.87,6.87,0,0,0-.88-1.58l1.52-.36h-3.8v-1.4h7.3v-1.12h-5.52v-1.36h5.52V228.4h-6.76V227h3.66a12.74,12.74,0,0,0-1-1.7l1.66-.55a7.39,7.39,0,0,1,1.16,1.81l-1.18.44H187a15.51,15.51,0,0,0,1.08-2.21l2,.39a20.79,20.79,0,0,1-1.1,1.82h3.68v1.4h-6.88v1.06h5.66v1.36h-5.66v1.12h7.5v1.4h-4l1.68.32c-.3.58-.6,1.14-.88,1.62Zm-13.22-1.94a6.61,6.61,0,0,1,1,1.7l-.86.24h7.42a13.84,13.84,0,0,0,.9-1.94Zm-1.92,4.38h12.5v5.4h-1.9v-.56h-8.76v.62h-1.84Zm1.84,1.46v1.92h8.76v-1.92Z"
                transform="translate(-1.3 -28.72)"
              />
              <path
                class="cls-3"
                d="M213.66,238.06v5.12h-1.84v-4.8l-6.3,1.06-.28-1.78,6.58-1.1V224.83h1.84v11.43l2.18-.36.28,1.74Zm-9.38-1a27.51,27.51,0,0,0-1.56-2.64v8.74h-1.8v-8.1a19.41,19.41,0,0,1-2.56,4.66,11.74,11.74,0,0,0-.9-1.72,19.89,19.89,0,0,0,3.2-5.86h-2.94v-1.74h3.2v-2.68c-.86.16-1.72.28-2.52.4a5.67,5.67,0,0,0-.52-1.44,30,30,0,0,0,6.36-1.62l1.06,1.52a18.89,18.89,0,0,1-2.58.76v3.06h2.8v1.74h-2.8v.28c.6.62,2.3,2.66,2.68,3.18Zm5.52-7a16.27,16.27,0,0,0-3.1-2.9l1.22-1.06a16.48,16.48,0,0,1,3.18,2.78Zm-.5,5.26a17.22,17.22,0,0,0-3.34-3l1.18-1.08a18.81,18.81,0,0,1,3.42,2.84Z"
                transform="translate(-1.3 -28.72)"
              />
              <path
                class="cls-3"
                d="M237.18,232.7a14.54,14.54,0,0,1-3.9,6.62,14,14,0,0,0,4.92,2.32,6.6,6.6,0,0,0-1.2,1.58,13.91,13.91,0,0,1-5.18-2.7,16.92,16.92,0,0,1-5.46,2.66,7.93,7.93,0,0,0-1-1.68,16.05,16.05,0,0,0,5.14-2.26,16.16,16.16,0,0,1-3.1-5.18l.26-.08h-.8v-1.7H231v-2.74H226.5v-1.7H231v-3h1.84v3h4.62v1.7h-4.62v2.74h2.84l.32-.06Zm-10.78,2.44-2.28.66v5.26c0,1-.2,1.46-.78,1.74a6.87,6.87,0,0,1-2.84.32,7.21,7.21,0,0,0-.56-1.68c.88,0,1.72,0,2,0s.4-.1.4-.38v-4.74c-.78.22-1.5.42-2.2.6l-.48-1.78,2.68-.64v-4h-2.46v-1.72h2.46v-3.93h1.82v3.91h2.1v1.74h-2.1V234l2.06-.54Zm2.82-1.16a12.64,12.64,0,0,0,2.68,4.12,11.89,11.89,0,0,0,2.92-4.12Z"
                transform="translate(-1.3 -28.72)"
              />
              <path
                class="cls-3"
                d="M259.18,225.68V243.2h-1.82v-.78H244.24v.78H242.5V225.68Zm-1.82,15.06V227.36H244.24v13.38Zm-.86-8.86H245.1v-1.1h4.82v-1h-3.76v-1.08h3.76v-1h1.68v1h4v1.08h-4v1h4.9Zm-5,6.28a4.32,4.32,0,0,0,0,1.14c-3.56,1-4.1,1.1-4.42,1.32a3.4,3.4,0,0,0-.46-1.06,1,1,0,0,0,.72-1.08v-1.14c-.64.24-1.28.46-1.9.64a7.36,7.36,0,0,0-.9-1.08,19.78,19.78,0,0,0,4.22-1.44h-2.56v-2.9h9.2v2.9h-4.54a11,11,0,0,1-2.14,1.28v2.06Zm-3.72-3.58h6v-1.12h-6Zm8.76,1.94a16.23,16.23,0,0,1-2,1.22c.8.56,1.54,1.1,2.08,1.56l-1.22.74a37.73,37.73,0,0,0-5.1-3.6l1.14-.66c.64.38,1.38.82,2.08,1.28a15.7,15.7,0,0,0,1.86-1.26Z"
                transform="translate(-1.3 -28.72)"
              />
              <path
                class="cls-3"
                d="M278.12,240.64a21.29,21.29,0,0,0,3.46-.24c.06.48.18,1.34.28,1.76a22.34,22.34,0,0,1-3.8.2h-8.38c-3.26,0-4.78-1-4.78-4.24v-10.8h-.8v-1.64h16.78v1.64H266.72v10.94c0,1.7.68,2.38,2.78,2.38Zm-.44-7.64h-7.56v-4.54h7.56Zm-1.84-3.28h-4v2h4Zm4.1,9.64h-5.46v-5.22h5.46ZM268,234.14h5.3v5.22H268Zm10.32,1.32H276V238h2.3Zm-8.8,2.58h2.18v-2.58h-2.18Z"
                transform="translate(-1.3 -28.72)"
              />
              <path
                class="cls-3"
                d="M293.38,224.75h1.54v22.49h-1.54Z"
                transform="translate(-1.3 -28.72)"
              />
              <path
                class="cls-3"
                d="M323.52,228.34v9.56h-1.94v-1.08h-5.2v6.36h-1.94v-6.36h-5.18V238H307.4v-9.66h7v-3.48h1.94v3.48ZM321.58,235v-4.84h-5.2V235Zm-7.14,0v-4.84h-5.18V235Z"
                transform="translate(-1.3 -28.72)"
              />
              <path
                class="cls-3"
                d="M339.92,227.78H337.8v-1.64h2.12v-1.31h1.82v1.31h4.46v1.64h-4.46v1.36h-1.82Zm-6.84,0h-4.4v-1.64h4.4v-1.31h1.82v1.31h2.18v1.64H334.9v1.36h-1.82Zm5.22,10v1.38h6.94v1.56H338.3v2.52h-1.82v-2.52H329.6v-1.56h6.88v-1.38h-7.94v-1.62h7.94V231.2H329v-1.56h16.88v1.56H338.3v4.92h8.14v1.62Zm-4.84-6.1v1.18h2.14v1.58h-2.14v1.28h-1.74V234.4H329v-1.58h2.68v-1.18Zm8,4v-1.36h-2.24v-1.58h2.24v-1.1h1.72v1.1h2.6v1.58h-2.6v1.36Z"
                transform="translate(-1.3 -28.72)"
              />
              <path
                class="cls-3"
                d="M356.68,228.68h4.46v1.56h-4.46V237h3.58v1.54h-3.58V240c1.34-.14,2.72-.3,4.08-.46l0,1.62c-3.56.48-7.32.92-10,1.24l-.22-1.76,4.42-.46V238.5h-4.06V237H355v-6.72h-4.48v-1.56H355v-1.26c-1.22.12-2.44.22-3.58.28a5.62,5.62,0,0,0-.46-1.46,56.58,56.58,0,0,0,8.92-1.26l.88,1.5a32,32,0,0,1-4.08.74Zm11.88-2c-.68,1.9-1.56,4.14-2.36,6a6.81,6.81,0,0,1,2.06,4.72,3.3,3.3,0,0,1-1,2.8,3.24,3.24,0,0,1-1.3.46,9.72,9.72,0,0,1-1.72,0,4.44,4.44,0,0,0-.5-1.82c.56,0,1,.06,1.4.06a2.07,2.07,0,0,0,.82-.22,1.7,1.7,0,0,0,.5-1.46,6.24,6.24,0,0,0-2.1-4.34c.64-1.58,1.38-3.7,1.86-5.26h-2.78V243.2h-1.72V225.88h5.18l.3-.06Zm-15.34,4.2v2h1.18v1.26h-1.18v2.24H351.9v-2.24h-1.32V232.8h1.32v-2Zm6.52,2h1.18v1.26h-1.18v2.2h-1.32v-2.2h-1.18v-1.26h1.18v-2h1.32Z"
                transform="translate(-1.3 -28.72)"
              />
              <path
                class="cls-3"
                d="M389.32,230.24a22.94,22.94,0,0,1-2.48,7.92,9.81,9.81,0,0,0,4,3.44,6.85,6.85,0,0,0-1.26,1.58,11,11,0,0,1-3.82-3.36,13.4,13.4,0,0,1-4.3,3.42,7.49,7.49,0,0,0-1.08-1.64,10.66,10.66,0,0,0,4.34-3.48,21.41,21.41,0,0,1-1.86-5c-.34.58-.68,1.1-1,1.6a8.31,8.31,0,0,0-1.12-1h-2.22v4.6l3.14-.66.18,1.68c-3.28.78-6.78,1.6-9.28,2.14l-.34-1.86,1.12-.22v-8.68h1.68V239l1.68-.36V227.94h-4.08v-1.8h9.08v1.8h-3.18v4h2.5v.62a21.31,21.31,0,0,0,2.66-7.7l1.84.32c-.22,1.16-.5,2.28-.8,3.36h6v1.74Zm-5.38.32a23.27,23.27,0,0,0,1.84,5.74,21.31,21.31,0,0,0,1.68-6.06h-3.4Z"
                transform="translate(-1.3 -28.72)"
              />
              <path
                class="cls-3"
                d="M412.5,228.06s0,.64,0,.88c-.44,9-.82,12.14-1.6,13.12a1.89,1.89,0,0,1-1.46.88,11.55,11.55,0,0,1-2.26,0,4.4,4.4,0,0,0-.52-1.82c.84.08,1.58.08,2,.08a.77.77,0,0,0,.72-.36c.58-.66,1-3.5,1.36-11.1h-.56c-1,5.16-3.16,10.42-6.4,13a8.43,8.43,0,0,0-1.54-1.1c3.22-2.3,5.32-7.08,6.32-11.92h-1.34c-.88,3.36-2.62,7-4.74,8.9a6.71,6.71,0,0,0-1.44-1.06c2.06-1.6,3.7-4.76,4.62-7.84h-1.42a15,15,0,0,1-2.16,3.68,14.14,14.14,0,0,0-1.44-1.06,16.94,16.94,0,0,0,3.42-7.57l1.68.33c-.22,1-.52,2-.82,2.9Zm-10.6,7.22c-.78.26-1.56.5-2.34.74v7.16h-1.72v-6.62l-3.14,1-.48-1.78c1-.26,2.26-.6,3.62-1v-4.2h-1.6a19.59,19.59,0,0,1-.82,2.78,11.21,11.21,0,0,0-1.36-.84,23.14,23.14,0,0,0,1.26-6.52l1.58.26c-.1.86-.2,1.72-.34,2.56h1.28v-4h1.72v4h1.86v1.76h-1.86v3.68l2.1-.6Z"
                transform="translate(-1.3 -28.72)"
              />
              <path
                class="cls-3"
                d="M433,234.28c-.24-.38-.58-.86-1-1.36-7.78.52-8.74.6-9.38.86a18.19,18.19,0,0,0-.6-1.74c.44-.1.9-.56,1.48-1.26a17,17,0,0,0,1.36-1.76h-3v-1.68h4.16c.48-.8,1-1.66,1.4-2.51l1.82.73c-.34.6-.72,1.2-1.08,1.78h6.06V229h-7.22q-1.11,1.5-2.22,2.76l6.1-.36c-.44-.52-.86-1-1.22-1.52l1.4-.8c1.12,1.32,2.66,3.14,3.42,4.22Zm-12.44-5.4a14.32,14.32,0,0,0-3.42-2.44l1-1.36a15.41,15.41,0,0,1,3.5,2.32Zm-.64,5.2a14.65,14.65,0,0,0-3.66-2.2l1-1.4a16.6,16.6,0,0,1,3.72,2Zm13.58,7.24a3.48,3.48,0,0,0,.9-.12c0,.46.08,1.06.14,1.44a3.18,3.18,0,0,1-1,.12h-1.18c-1.56,0-1.86-.66-1.86-2.26v-6.22h1.72v6.26c0,.58,0,.78.3.78Zm-9.94-7h1.68v2c0,2.2-.32,4.86-2.88,6.82a5.79,5.79,0,0,0-1.3-1.22,6.38,6.38,0,0,0,2.5-5.64Zm3.46.16h1.64v7.9H427Zm-5.18,2.16c-1.06,2.08-2.38,4.46-3.58,6.36l-1.56-1.26a59.79,59.79,0,0,0,3.76-6.34Z"
                transform="translate(-1.3 -28.72)"
              />
              <path
                class="cls-3"
                d="M455.52,228.34v9.56h-1.94v-1.08h-5.2v6.36h-1.94v-6.36h-5.18V238H439.4v-9.66h7v-3.48h1.94v3.48ZM453.58,235v-4.84h-5.2V235Zm-7.14,0v-4.84h-5.18V235Z"
                transform="translate(-1.3 -28.72)"
              />
              <path
                class="cls-3"
                d="M467.48,225.38a36.55,36.55,0,0,1,5.46,4.28l-1.38,1.42a35.28,35.28,0,0,0-5.34-4.46Zm-.16,5.06V240c0,.94.22,1.1,1.28,1.1H472c1.14,0,1.32-.66,1.46-4a5.68,5.68,0,0,0,1.74.8c-.22,3.76-.76,4.9-3.08,4.9h-3.7c-2.34,0-3-.64-3-2.84v-9.54Zm8.82.76a35.6,35.6,0,0,1,2.64,7.44l-1.86.78a36.12,36.12,0,0,0-2.5-7.54Zm-12.26.92a44.16,44.16,0,0,1-1.64,8l-1.86-.78a33.65,33.65,0,0,0,1.68-7.58Z"
                transform="translate(-1.3 -28.72)"
              />
              <path
                class="cls-3"
                d="M123.44,267.74v1.9h-15v-1.9Zm-1.56,6.42v1.9H109.74v-1.9ZM124.5,281v1.88H107.3V281Z"
                transform="translate(-1.3 -28.72)"
              />
              <path
                class="cls-3"
                d="M139.4,273.3c1.36,4.16,3.88,7.54,7.66,9.12a7.36,7.36,0,0,0-1.38,1.74c-3.74-1.74-6.16-5-7.72-9.22a13.84,13.84,0,0,1-7.72,9.22,6.49,6.49,0,0,0-1.42-1.56,12.44,12.44,0,0,0,7.5-9.3h-7.1v-1.92h7.44a50.16,50.16,0,0,0,.24-5.52h2a50.45,50.45,0,0,1-.28,5.52h8.06v1.92Z"
                transform="translate(-1.3 -28.72)"
              />
              <path
                class="cls-3"
                d="M168.26,266.68V284.2h-1.82v-.78H153.32v.78h-1.74V266.68Zm-1.82,15.06V268.36H153.32v13.38Zm-.86-8.86h-11.4v-1.1H159v-1h-3.76v-1.08H159v-1h1.68v1h4v1.08h-4v1h4.9Zm-5,6.28a4.32,4.32,0,0,0,0,1.14c-3.56,1-4.1,1.1-4.42,1.32a3.4,3.4,0,0,0-.46-1.06,1,1,0,0,0,.72-1.08v-1.14c-.64.24-1.28.46-1.9.64a7.36,7.36,0,0,0-.9-1.08,19.78,19.78,0,0,0,4.22-1.44h-2.56v-2.9h9.2v2.9H160a11,11,0,0,1-2.14,1.28v2.06Zm-3.72-3.58h6v-1.12h-6Zm8.76,1.94a16.23,16.23,0,0,1-2,1.22c.8.56,1.54,1.1,2.08,1.56l-1.22.74a37.73,37.73,0,0,0-5.1-3.6l1.14-.66c.64.38,1.38.82,2.08,1.28a15.7,15.7,0,0,0,1.86-1.26Z"
                transform="translate(-1.3 -28.72)"
              />
              <path
                class="cls-3"
                d="M187.2,281.64a21.29,21.29,0,0,0,3.46-.24c.06.48.18,1.34.28,1.76a22.34,22.34,0,0,1-3.8.2h-8.38c-3.26,0-4.78-1-4.78-4.24v-10.8h-.8v-1.64H190v1.64H175.8v10.94c0,1.7.68,2.38,2.78,2.38Zm-.44-7.64H179.2v-4.54h7.56Zm-1.84-3.28h-4v2h4Zm4.1,9.64h-5.46v-5.22H189Zm-11.94-5.22h5.3v5.22h-5.3Zm10.32,1.32h-2.3V279h2.3ZM178.6,279h2.18v-2.58H178.6Z"
                transform="translate(-1.3 -28.72)"
              />
              <path
                class="cls-3"
                d="M201.32,272.12h4.6v1.7h-4.6v1.78h4v5.26c0,.76-.12,1.24-.64,1.52a5,5,0,0,1-2.32.28,4.69,4.69,0,0,0-.5-1.58c.72,0,1.32,0,1.52,0s.26-.06.26-.26v-3.56h-2.32v6.92h-1.76v-6.92h-2.18v5.34h-1.66v-7h3.84v-1.78h-4.7v-1.7h1.38a12.12,12.12,0,0,0-1.56-.64,15.38,15.38,0,0,0,1.92-5.2l1.74.36c-.16.66-.34,1.34-.52,2h1.74V266h1.76v2.66h3.82v1.68h-3.82Zm11.14-6v15.7c0,1.12-.24,1.64-.9,2a8.47,8.47,0,0,1-3.26.36,8.31,8.31,0,0,0-.6-1.9c1.12,0,2.2,0,2.54,0s.42-.1.42-.42V266.12Zm-3.6,12.54h-1.72V267.6h1.72Zm-9.3-6.54V270.3h-2.34a10.29,10.29,0,0,1-.88,1.82Z"
                transform="translate(-1.3 -28.72)"
              />
              <path
                class="cls-3"
                d="M234.46,268.68v3.24h-1.72v-2.1h-1.32l.6.82a21.25,21.25,0,0,1-3.54.86,26.82,26.82,0,0,1,4,.9l-.32,1.12a29.16,29.16,0,0,0-4.66-1.1l.38-1,.42.06-.54-.8a27,27,0,0,0,3.12-.86h-4.08v3.78H225v-3.78h-4.18a21,21,0,0,1,3.4.78l-.46,1,.44-.06.08,1.08c-1.54.32-3,.64-4.32.9l-.48-1.32c1.1-.12,2.6-.32,4.16-.58a28.28,28.28,0,0,0-3.56-.86l.44-.9h-1.42v2.1H217.4v-3.24H225v-.82h-6.32v-1.3h14.54v1.3h-6.42v.82Zm-12,13.92v1.58h-1.58V282.6H217v-1.18h3.9v-.7H217.8v-2.9h3.12v-.62h-2.06v-1.7h-1.72v-1.16h1.72v-.74h1.46v.74h2.94v-.74h1.5v.74h1.7v1.16h-1.7v1.7H222.5v.62h3.24v2.9H222.5v.7h3.68v1.18Zm11.52-.26c0,.82-.16,1.24-.7,1.5a7.8,7.8,0,0,1-2.72.26,5.27,5.27,0,0,0-.46-1.48c.82,0,1.62,0,1.86,0s.34-.1.34-.32v-1.58H228.6a7.26,7.26,0,0,1-1.44,3.5,9.15,9.15,0,0,0-1.44-.8c1.34-1.62,1.5-3.88,1.5-5.62v-3.7H234Zm-13.7-6.08h2.94v-.76h-2.94Zm8.52-.72v1.3h3.5v-1.3Zm3.5,3.92v-1.34h-3.5c0,.42,0,.88-.06,1.34Zm-9.84-.68v1h1.8v-1Zm-1.58,1v-1h-1.74v1Z"
                transform="translate(-1.3 -28.72)"
              />
              <path
                class="cls-3"
                d="M246.66,278.42h-5.12l-1.26,4.2h-2.36l4.88-14.72h2.68l4.88,14.72H247.9Zm-.56-1.82-.58-2c-.5-1.6-.94-3.24-1.4-4.9H244c-.42,1.68-.88,3.3-1.36,4.9l-.6,2Z"
                transform="translate(-1.3 -28.72)"
              />
              <path
                class="cls-3"
                d="M260.26,269.84h-6.92V267.9h9.48v1.4c-3.46,4.32-4,7.56-4.24,13.32h-2.36C256.48,277.24,257.42,273.8,260.26,269.84Z"
                transform="translate(-1.3 -28.72)"
              />
              <path
                class="cls-3"
                d="M284.44,267.84v1.58H267v-1.58h7.94c-.18-.54-.38-1.14-.56-1.64l1.88-.45c.26.65.58,1.45.78,2.09Zm-2.58,2.54v4.1h-12v-4.1Zm-2,1.3h-8.2v1.48h8.2Zm4,10.68c0,.88-.22,1.22-.84,1.46a9.2,9.2,0,0,1-2.88.22,6.33,6.33,0,0,0-.58-1.38c.84,0,1.84,0,2.06,0s.36-.08.36-.32V277H269.46v7.22h-1.82v-8.76H283.9Zm-10.78-.18v.92H271.4V278h8.48v4.22Zm0-2.88v1.54h5.12V279.3Z"
                transform="translate(-1.3 -28.72)"
              />
              <path
                class="cls-3"
                d="M304.58,279.06v5.12h-1.84v-4.8l-6.3,1.06-.28-1.78,6.58-1.1V265.83h1.84v11.43l2.18-.36.28,1.74Zm-9.38-1a27.51,27.51,0,0,0-1.56-2.64v8.74h-1.8v-8.1a19.41,19.41,0,0,1-2.56,4.66,11.74,11.74,0,0,0-.9-1.72,19.89,19.89,0,0,0,3.2-5.86h-2.94v-1.74h3.2v-2.68c-.86.16-1.72.28-2.52.4a5.67,5.67,0,0,0-.52-1.44,30,30,0,0,0,6.36-1.62l1.06,1.52a18.89,18.89,0,0,1-2.58.76v3.06h2.8v1.74h-2.8v.28c.6.62,2.3,2.66,2.68,3.18Zm5.52-7a16.27,16.27,0,0,0-3.1-2.9l1.22-1.06a16.48,16.48,0,0,1,3.18,2.78Zm-.5,5.26a17.22,17.22,0,0,0-3.34-3l1.18-1.08a18.81,18.81,0,0,1,3.42,2.84Z"
                transform="translate(-1.3 -28.72)"
              />
              <path
                class="cls-3"
                d="M328.1,273.7a14.54,14.54,0,0,1-3.9,6.62,14,14,0,0,0,4.92,2.32,6.6,6.6,0,0,0-1.2,1.58,13.91,13.91,0,0,1-5.18-2.7,16.92,16.92,0,0,1-5.46,2.66,7.93,7.93,0,0,0-1-1.68,16.05,16.05,0,0,0,5.14-2.26,16.16,16.16,0,0,1-3.1-5.18l.26-.08h-.8v-1.7h4.12v-2.74h-4.48v-1.7h4.48v-3h1.84v3h4.62v1.7h-4.62v2.74h2.84l.32-.06Zm-10.78,2.44-2.28.66v5.26c0,1-.2,1.46-.78,1.74a6.87,6.87,0,0,1-2.84.32,7.21,7.21,0,0,0-.56-1.68c.88,0,1.72,0,2,0s.4-.1.4-.38v-4.74c-.78.22-1.5.42-2.2.6l-.48-1.78,2.68-.64v-4h-2.46v-1.72h2.46v-3.93H315v3.91h2.1v1.74H315V275l2.06-.54Zm2.82-1.16a12.64,12.64,0,0,0,2.68,4.12,11.89,11.89,0,0,0,2.92-4.12Z"
                transform="translate(-1.3 -28.72)"
              />
              <path
                class="cls-3"
                d="M350.76,267.46v1.62H335.68v4.44c0,3.1-.24,7.76-1.78,10.78a7.56,7.56,0,0,0-1.46-1.1c1.38-2.8,1.48-6.82,1.48-9.68v-6.06h7.94c-.18-.46-.36-.94-.54-1.34l1.74-.42c.26.54.56,1.22.78,1.76Zm-9.06,10.86a36.16,36.16,0,0,1,2.24,4.32l-1.5.7a14.29,14.29,0,0,0-.6-1.46c-4.08,1.34-4.7,1.58-5.1,1.88a6.2,6.2,0,0,0-.88-1.3,2.14,2.14,0,0,0,.92-1.76v-9.62h2.74c-.16-.48-.36-1-.52-1.38l1.56-.36a12.81,12.81,0,0,1,.72,1.74h2v6.78h-4.86v3.54l2.72-.84c-.28-.6-.6-1.18-.9-1.7Zm8.88-7.52c-.58,1.46-1.3,3.16-2,4.56a5.46,5.46,0,0,1,1.8,3.86,2.65,2.65,0,0,1-.86,2.3,2.6,2.6,0,0,1-1.06.4,11.18,11.18,0,0,1-1.44,0,3.74,3.74,0,0,0-.4-1.52,11,11,0,0,0,1.12,0,1.19,1.19,0,0,0,.62-.16c.3-.2.4-.64.4-1.22a5,5,0,0,0-1.78-3.52,38.87,38.87,0,0,0,1.46-3.8h-2.28v12.5h-1.64v-14h4.6l.24-.08Zm-12.12,1.64v1.36h3.22v-1.36Zm3.22,4.06v-1.44h-3.22v1.44Z"
                transform="translate(-1.3 -28.72)"
              />
              <path
                class="cls-3"
                d="M359.58,269.6a4.93,4.93,0,0,1-3.38,3.9,5.74,5.74,0,0,0-1.08-1.26,3.58,3.58,0,0,0,2.76-2.64H355v-1.46h3v-2h1.68v2h1.48v-2h1.62v2h2.08v-2h1.7v2H368v-2.08h1.66v2.08h2.88v1.46H369.7v1.2c0,.54,0,.72.38.72h1.42a5.73,5.73,0,0,0,1-.1c0,.42.08,1,.14,1.44a4.71,4.71,0,0,1-1.16.1h-1.58c-1.58,0-1.9-.64-1.9-2.2V269.6h-1.52v3.18h-5.4V269.6Zm3.16,0v1.76h2.08V269.6Zm-7.4,4.06h17v4h-1.8v-2.5H357.06v2.5h-1.72Zm15.12,7.58c0,.84-.2,1.34-.86,1.58a9.69,9.69,0,0,1-3.12.26,6.17,6.17,0,0,0-.58-1.6c1,0,2.08,0,2.34,0s.38-.08.38-.32v-2.74h-4v5.72h-1.84v-5.72h-3.68V283h-1.8V277h5.48v-1.44h1.84V277h5.86Z"
                transform="translate(-1.3 -28.72)"
              />
              <path
                class="cls-3"
                d="M155.84,313.34a15.68,15.68,0,0,1-1.32,1.44,7.1,7.1,0,0,0-1-1.64,17.18,17.18,0,0,0,4.42-6.47l1.4.87c-.14.34-.3.68-.46,1a30.53,30.53,0,0,1,3.36,3.78l-.94,1.48A29.2,29.2,0,0,0,158.1,310a24.22,24.22,0,0,1-1.9,2.9h4.26v1.58h-4.62Zm9.86-2.4c.1-.52.22-1.12.28-1.64h-3.9v-1.58h9.74v1.58H168c-.18.56-.34,1.14-.52,1.64h3.8v10.42h-8.5V310.94Zm3.84,1.42h-5.1V314h5.1Zm0,2.94h-5.1V317h5.1ZM162,316.78a22.93,22.93,0,0,1-3.08,5.52,18.13,18.13,0,0,1,1.4,1.56L159.08,325a27.25,27.25,0,0,0-4.06-4.18l1.14-1c.48.36,1,.82,1.54,1.3a18.33,18.33,0,0,0,2.14-3.42H154.4v-1.54h6.2l.28-.1Zm7.54,1.5h-5.1V320h5.1Zm-3.16,4.26a13.85,13.85,0,0,1-4.06,2.7A10,10,0,0,0,161.1,324a11.8,11.8,0,0,0,3.74-2.46Zm2.62-.86a24.31,24.31,0,0,1,3.22,2.5l-1.46,1.06a22.36,22.36,0,0,0-3.14-2.64Z"
                transform="translate(-1.3 -28.72)"
              />
              <path
                class="cls-3"
                d="M183.26,315.12c-.62.64-1.26,1.28-1.78,1.8.62.66,1.24,1.34,1.44,1.62l-1,1.48c-.34-.56-1-1.5-1.66-2.36v7.54h-1.82v-7.52a17.31,17.31,0,0,1-2.2,2.18,9.48,9.48,0,0,0-.82-1.82A17.31,17.31,0,0,0,180.3,312h-4.42V310.3h3.54a25.06,25.06,0,0,0-1.66-2.74l1.44-.77a17.42,17.42,0,0,1,1.7,2.61l-1.44.9h1.72l.32-.1.94.76a23.79,23.79,0,0,1-2.18,4.26v.4l.42.4a14.79,14.79,0,0,0,1.46-1.92Zm10.1-4v14h-1.82v-1H185.2v1.14h-1.76V311.1h4.06v-4.27h1.86v4.27Zm-8.16,1.68v3.82h2.42v-3.82Zm6.34,0h-2.3v3.82h2.3Zm-6.34,9.64h2.42v-4.16H185.2Zm6.34,0v-4.16h-2.3v4.16Z"
                transform="translate(-1.3 -28.72)"
              />
              <path
                class="cls-3"
                d="M210,309.4h-2.82v-1.46H210v-1.12h1.84v1.12h3.78v1.46h-3.78v1.14H210Zm-8.14,0h-3.82v-1.46h3.82v-1.12h1.82v1.12h2.72v1.46h-2.72v1.14H201.9Zm13.82,6v1.36H198v-1.36h7.86v-.94h-5.92v-1.2h5.92v-.92h-6.62V311h6.62v-.84h1.84V311h6.9v1.26h-6.9v.92h6.24v1.2H207.7v.94Zm-2.38,8.12c0,.86-.2,1.24-.84,1.46a9.85,9.85,0,0,1-3.12.22,7.32,7.32,0,0,0-.58-1.36c1,0,2.06,0,2.3,0s.4-.08.4-.34v-.84h-9.56a4.93,4.93,0,0,1-1.84,2.7,7.2,7.2,0,0,0-1.32-1.38,4.13,4.13,0,0,0,1.66-3.76v-2.68h12.9Zm-11.08-4.72v.84h9.24v-.84Zm9.24,2.8v-.88h-9.24c0,.3,0,.58-.08.88Z"
                transform="translate(-1.3 -28.72)"
              />
              <path
                class="cls-3"
                d="M232.12,310.3h-2.84v-1.58h2.84v-1.86H234v1.86h3.44v1.58H234v1.82h-1.88Zm-8.26,0h-3.54v-1.58h3.54v-1.88h1.86v1.88h2.62v1.58h-2.62v1.84h-1.86Zm5.42,9.18c-.78,2.36-3,4.4-8.56,5.7a6.72,6.72,0,0,0-1.12-1.52c4.82-1,6.82-2.5,7.66-4.18h-7.38v-1.72H222V313h5.78v-1.82h1.9V313h6.14v4.8h2v1.72Zm.4-4.9v2.2c0,.34,0,.64,0,1h4.3V314.6Zm-2,3.18a8.39,8.39,0,0,0,.06-1V314.6h-4v3.18Zm2.3,2a48,48,0,0,1,7.86,3.88l-.94,1.52a50,50,0,0,0-7.8-4.08Z"
                transform="translate(-1.3 -28.72)"
              />
              <path
                class="cls-3"
                d="M252,311.28c-.22.54-.44,1.08-.66,1.56h6.22V325.2h-1.94v-1H246v1H244.1V312.84h5.24c.14-.5.3-1.06.4-1.56H242v-1.72h4.88a16.59,16.59,0,0,0-1.56-2.08l1.64-.73a12.56,12.56,0,0,1,1.9,2.35l-.88.46h5a20.22,20.22,0,0,0,1.68-2.74l2.1.48c-.54.8-1.14,1.6-1.68,2.26h4.76v1.72Zm3.62,3.18H246v1.66h9.66Zm0,3.12H246v1.7h9.66Zm0,5v-1.8H246v1.8Z"
                transform="translate(-1.3 -28.72)"
              />
              <path
                class="cls-3"
                d="M266.12,310.8c-.28-.9-.82-2.34-1.2-3.4l1.68-.46c.4,1.06,1,2.44,1.24,3.3Zm8.56,1a11.55,11.55,0,0,0-.32,1.34c-3.92.66-4.54.8-4.88,1a5.86,5.86,0,0,0-.62-1.4,1.23,1.23,0,0,0,.56-1.2v-4h5.44v3.56h-4v1.26Zm2.94,1.8c-1.54,0-1.92-.58-1.92-2.06v-4h5.52v3.56h-4v.44c0,.54.06.74.52.74H280a6.53,6.53,0,0,0,1.3-.12c0,.4.08,1,.14,1.3a5.16,5.16,0,0,1-1.38.12Zm-6.72-4.86v1.14h2.4v-1.14Zm6.3,0v1.14h2.42v-1.14Zm-8.5,7.64a19.54,19.54,0,0,1-1.56,4.94c.4.22.82.56,1.56,1,1.36.84,3.2,1,5.54,1a73.37,73.37,0,0,0,8-.46,6.92,6.92,0,0,0-.54,1.92c-1.54.1-5.22.22-7.56.22-2.64,0-4.34-.22-5.78-1.06-.82-.46-1.54-1.16-2-1.16s-1.14,1.3-1.66,2.52l-1.28-1.72a12.63,12.63,0,0,1,1.56-1.74l0,0a12.66,12.66,0,0,0,1.76-4.2h-2.52c.5-1.18,1.08-2.8,1.58-4.36h-2v-1.68h4.32c-.44,1.42-1,3.06-1.5,4.44h.7l.28-.06Zm5.8,3.7a16.93,16.93,0,0,1-4,2.58,8.54,8.54,0,0,0-1.38-1.14,13.42,13.42,0,0,0,3.7-2h-4v-1.42h3.32V316.6h-2.56v-1.4h2.56v-1.26h1.7v1.26h2.78v-1.26h1.72v1.26h2.62v1.4h-2.62v1.58h3.44v1.42h-4.3a23,23,0,0,1,3.8,2.22l-1.62.8a22,22,0,0,0-3.56-2.28l1-.74H273Zm-.68-1.94h2.78V316.6h-2.78Z"
                transform="translate(-1.3 -28.72)"
              />
              <path
                class="cls-3"
                d="M297.32,310.62a15.73,15.73,0,0,0-1.54-3.26l1.7-.61a18.53,18.53,0,0,1,1.66,3.19Zm-5.22-3.14a32,32,0,0,1-2,4.2v13.48h-1.88V314.6a18.08,18.08,0,0,1-1.64,2,11.21,11.21,0,0,0-1-1.92,22,22,0,0,0,4.76-7.7Zm12,15.28v1.78H291.24v-1.78h5.56V318.2h-4.4v-1.76h4.4v-4h-5.08v-1.78h12.06v1.78h-5.1v4h4.52v1.76h-4.52v4.56Z"
                transform="translate(-1.3 -28.72)"
              />
              <path
                class="cls-3"
                d="M319.4,316.64v2h4.76v6.5h-1.84v-.62h-7.66v.64h-1.78v-6.52h4.66v-2h-6c-.2,2.94-.78,6.24-2.34,8.6a7.57,7.57,0,0,0-1.66-1c2.06-3.06,2.22-7.44,2.22-10.62v-5.78H324.5V313h-5.1v2h6.18v1.68Zm-7.8-7.14v1.86h11V309.5Zm5.94,5.46v-2H311.6v.64c0,.42,0,.86,0,1.32Zm4.78,5.34h-7.66v2.62h7.66Z"
                transform="translate(-1.3 -28.72)"
              />
              <rect
                class="cls-4"
                x="143.85"
                y="170.15"
                width="185"
                height="0.5"
              />
              <rect
                class="cls-4"
                x="143.85"
                y="122.15"
                width="185"
                height="0.5"
              />
              <text class="cls-5" transform="translate(143.74 155.76)">
                體驗/未來與成就
              </text>
            </g>
          </g>
        </g>
      </svg>

      <svg
        v-if="isMobile"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 325 331.05"
      >
        <g id="圖層_2" data-name="圖層 2">
          <g id="圖層_1-2" data-name="圖層 1">
            <rect
              class="cls-1"
              x="76.01"
              y="96.94"
              width="168.89"
              height="0.51"
            />
            <rect
              class="cls-1"
              x="76.01"
              y="130.72"
              width="168.89"
              height="0.51"
            />
            <text class="cls-2" transform="translate(78.57 122.13)">
              體驗/未來與成就
            </text>
            <text class="cls-3" transform="translate(101.09 27.02)">
              全台最美
              <tspan x="-46.06" y="46.06">科學園區第一排</tspan>
            </text>
            <text class="cls-4" transform="translate(108.46 169.14)">
              華亞科學園區
              <tspan x="0" y="30.71">樂善科技園區</tspan>
              <tspan x="-18.01" y="61.41">中華郵政物流中心</tspan>
            </text>
            <text class="cls-5" transform="translate(2.56 284.3)">
              三大園區制霸A7高科技廊帶領袖菁英首選
              <tspan x="143.14" y="30">住居</tspan>
            </text>
            <polygon
              class="cls-1"
              points="32.5 248.21 65 247.96 97.5 247.87 162.5 247.71 227.5 247.87 260 247.96 292.5 248.21 260 248.45 227.5 248.54 162.5 248.7 97.5 248.54 65 248.45 32.5 248.21"
            />
          </g>
        </g>
      </svg>
    </div>
  </div>
</template>
<style lang="scss" scoped>
@import "~@/assets/style/variableDefault.scss";
/* 螢幕尺寸標準 */
.section4 {
  width: 100%;
  height: 70vw;
  background-color: rgba(96, 96, 96, 0.2);

  .txt {
    width: 100%;
    position: absolute;
    top: calc(50% - 14vw);
    width: 30vw;
    height: 28vw;
    z-index: 1;
    left: 10vw;
    color: #fff;
    font-size: calc(100vw * 21 / 1920);
    line-height: 2;
    background: #b59668;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    letter-spacing: 0.1em;

    .title1 {
      font-weight: 700;
      line-height: 1.3;
      font-size: 1.8em;
    }
    .title2 {
      font-weight: 600;
      font-size: 1.2em;
      padding: 0;
      margin: 1.3em 0 0.9em 0;
      border: solid currentColor;
      border-width: 1px 0 1px 0;
    }
    .desc1 {
      font-weight: 400;
      font-size: 1em;
      hr {
        display: inline-block;
        width: 1em;
        border: 0;
        background: currentColor;
        height: 1px;
        transform: rotate(90deg);
        transform-origin: center center;
        vertical-align: middle;
      }
    }
    .desc2 {
      font-weight: 400;
      font-size: 1em;
    }
  }

  .title {
    display: none;
    background: #b59668;
    width: 30vw;
    height: 28vw;
    position: absolute;
    z-index: 1;
    top: calc(50% - 14vw);
    left: 10vw;

    svg {
      position: relative;
      width: 90%;
      top: 50%;
      transform: translateY(-50%);

      .cls-1 {
        fill: none;
      }
      .cls-2 {
        clip-path: url(#clip-path);
      }
      .cls-3,
      .cls-5 {
        fill: #f4f1f2;
      }
      .cls-4 {
        fill: #fff;
      }
      .cls-5 {
        font-size: 23px;
        font-family: NotoSansCJKtc-Black-B5pc-H, Noto Sans CJK TC;
        letter-spacing: 0.1em;
        font-weight: bold;
      }
    }
  }

  .swiper-container {
    width: 70vw;
    top: 50%;
    right: 0;
    transform: translateY(-50%) translateX(8vw);

    .swiper-slide {
      height: 50vw;
      background-size: cover;
      background-position: center center;

      p {
        color: #fff;
        position: absolute;
        right: 15px;
        bottom: 15px;
        letter-spacing: 1px;
      }
    }

    .swiper-button-next {
      color: #fff;
      width: 50px;
      height: 50px;
      text-align: center;
      border: 1px solid #fff;
      border-radius: 100%;
      &:after {
        font-size: 20px;
        font-weight: bolder;
      }
    }

    .swiper-button-prev {
      color: #fff;
      width: 50px;
      height: 50px;
      text-align: center;
      border: 1px solid #fff;
      border-radius: 100%;
      &:after {
        font-size: 20px;
        font-weight: bolder;
      }
    }
  }
}

/* 平板尺寸 */
@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) {
}

/* 手機尺寸 */
@media only screen and (max-width: 767px) {
  .section4 {
    width: 100vw;
    height: 210vw;
    margin-top: 10vw;

    .txt {
      width: 100%;
      height: 110vw;
      top: 0;
      left: 0;
      font-size: calc(100vw * 16 / 375);
      .title2 {
        margin: 1.3em 0 0.5em 0;
      }
      .desc2 {
        border-top: 1px solid #fff;
        margin-top: 0.5em;
        padding-top: 0.5em;
      }
    }

    .title {
      width: 100%;
      height: 110vw;
      position: absolute;
      z-index: 1;
      top: 0;
      left: unset;
      transform: unset;

      svg {
        .cls-1 {
          fill: #fff;
        }
        .cls-2 {
          font-size: 20.47px;
          letter-spacing: 0.1em;
          font-weight: bold;
        }
        .cls-2,
        .cls-3,
        .cls-4,
        .cls-5 {
          fill: #f4f1f2;
        }
        .cls-2,
        .cls-3 {
          font-family: NotoSansCJKtc-Black-B5pc-H, Noto Sans CJK TC;
        }
        .cls-3 {
          font-size: 30.71px;
        }
        .cls-4 {
          font-size: 16.38px;
          letter-spacing: 0.1em;
        }
        .cls-4,
        .cls-5 {
          font-family: NotoSansCJKtc-Medium-B5pc-H, Noto Sans CJK TC;
        }
        .cls-5 {
          font-size: 16px;
          letter-spacing: 0.1em;
        }
      }
    }

    .swiper-container {
      width: 100%;
      top: 100%;
      transform: translateY(-100%);
      .swiper-slide {
        height: 100vw;
      }
    }
  }
}

// 避免內容電腦過渡平板時，設計未考量的調整
@media only screen and (min-width: 1025px) and (max-width: 1199.98px) {
}

// 避免過度到 1280 x 720 時，設計未考量的調整
@media only screen and (min-width: 1025px) and (max-width: 1280px) {
}
</style>

<script>
// @ is an alias to /src
import { isMobile } from "@/utils";

export default {
  name: "section3",
  data() {
    return {
      isMobile,
      swiperOptions: {
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        },
        autoplay: true,
        speed: 1000,
        slidesPerView: isMobile ? 1 : 1,
        spaceBetween: isMobile ? 0 : 0,
        resistanceRatio: isMobile ? 1 : 0,
        loop: isMobile ? false : false
      },
      swiperList: [
        {
          id: "0001",
          imgUrl: require("./s4/1.jpg"),
          title: "樂善科技園區"
        },
        {
          id: "0002",
          imgUrl: require("./s4/2.jpg"),
          title: "華亞科技園區"
        },
        {
          id: "0003",
          imgUrl: require("./s4/3.jpg"),
          title: "中華郵政物流中心"
        }
      ]
    };
  },
  methods: {
    prev() {
      this.$refs.swiper.$swiper.slidePrev();
    },
    next() {
      this.$refs.swiper.$swiper.slideNext();
    }
  },
  created() {},
  mounted() {}
};
</script>
